import { AppData, Img, Lightning, Log, Router, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup'
import { fetchData, getPolicyUrl } from '../lib/models/data-service'
import { Logger } from '../lib/logger'
import PolicyTab from '../widgets/about/policy'
import CAInfo from '../widgets/about/ca-info'
import LoadingIcon from '../widgets/loading/loading-icon'
import MoreInfoUI from '../widgets/about/MoreInfoUI'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from '../lib/enum'
import { IDialogueButton, IDialogueInfo } from '../lib/interfaces'
import OnlyUrl from '../widgets/about/only-url'
import { Helper } from '../lib/helper'

export interface SettingsScreenTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  page: any
}

export default class SettingsScreen
  extends Lightning.Component<SettingsScreenTemplateSpec>
  implements Lightning.Component<SettingsScreenTemplateSpec> {
  prevPage: string = 'grid';
  page: any
  isLoaded = false
  index = 0;
  menuItems: any[] = [];
  aboutText = ''
  policyText = ''
  termsText = ''
  selectedIndex = 0;
  selectedRow = 0;
  selectedColumn = 0;
  isMenuFocused = false

  moreOptions = [
    [
      { id: 'clearwatched', content: 'Clear Recently Watched', userlog: 'SettingsScreen_clearwatched', icon: Utils.asset('images/ico-more-clearwatched.png'), actionIndex: 0 },
      { id: 'clearwatchlist', content: 'Clear Watchlist', userlog: 'SettingsScreen_clearwatchlist', icon: Utils.asset('images/ico-clearwatchlist.png'), actionIndex: 1 },
      { id: 'aboutus', content: 'About Us', userlog: 'settingsScreen_about', icon: Utils.asset('images/ico-more-about.png'), actionIndex: 2, description: "To View About Us, Scan the QR code below with your mobile device Or Visit https://futuretodayinc.com/about-us", qrCodeIcon: Utils.asset('images/qr-about.png')},
    ],
    [
      { id: 'privacypolicy', content: 'Privacy Policy', userlog: 'settingsScreen_privacy', icon: Utils.asset('images/ico-more-privacy.png'), actionIndex: 3, description: "To View Privacy Policy, scan the QR code below with your mobile device or visit https://futuretodayinc.com/privacy", qrCodeIcon: Utils.asset('images/qr-privacy.png')},
      { id: 'termsofuse', content: 'Terms of Use', userlog: 'settingsScreen_terms', icon: Utils.asset('images/ico-more-terms.png'), actionIndex: 4, description: "To View Terms of Use, scan the QR code below with your mobile device or visit https://futuretodayinc.com/terms", qrCodeIcon: Utils.asset('images/qr-terms.png')},
      { id: 'donotsell', content: 'Do Not Sell My info', userlog: 'SettingsScreen_donotsell', icon: Utils.asset('images/ico-more-donotsell.png'), actionIndex: 5, description: "To View Do Not Sell, scan the QR code below with your mobile device or visit https://futuretodayinc.com/privacy#do_not_sell", qrCodeIcon: Utils.asset('images/qr-donotsell.png') },
    ],
    [
      { id: 'appInfo', content: 'Information', userlog: 'settingsScreen_info', icon: Utils.asset('images/ico-more-info.png'), actionIndex: 6 },
    ]
  ]

  static override _template(): Lightning.Component.Template<SettingsScreenTemplateSpec> {
    return {
      ...super._template(),
      w: 1920,
      h: 1080,
      alpha: 0,
      rect: true,
      collision: true,
      MenuWrapper: {
        w: (w) => w,
        h: (h) => h,
        collision: true,
        type: MoreInfoUI,
      },
      ContentContainer: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        zIndex: 10,
        color: 0xff0D0E1E,
        alpha: 0,
        collision: true,
        Content: undefined,
        BackButton: {
          x: 60,
          y: 90,
          h: 40,
          zIndex: 15,
          alpha: 0.7,
          collision: true,
          texture: {
            src: Utils.asset('images/ico-back.png'),
            resizeMode: {
              h: 40,
              w: 40,
              type: 'contain',
            },
            type: Lightning.textures.ImageTexture
          }
        }
      }
    }
  }

  showHideLoading(state: boolean) {
    if (state) {
      this.patch({
        Loading: {
          flexItem: false,
          type: LoadingIcon
        }
      })
    } else {
      this.patch({
        Loading: undefined
      })
    }
  }

  $menuInfoItemFocused(item) {
    Log.info('menuInfoItemFocused', item)
    this.selectedRow = item.rowIndex
    this.selectedColumn = item.itemIndex
  }

  override _init() {
    this.tag('MenuWrapper').patch({
      moreOptions: this.moreOptions
    })
  }

  override _firstActive(): void {
    this.showHideMenu(true)
    this._setState('MenuWrapper');
  }

  showHideMenu(state) {
    const { appConfig } = AppData as AppSetup
    if(appConfig?.appEnv == 'auto') {
      this.widgets.menu.visible = false
      return
    }
    this.widgets.menu.visible = state
  }

  $enterContent({ rowIndex, itemIndex }) {
    Log.info('enterContent Item Index', itemIndex, rowIndex)
    if (rowIndex === 0 && itemIndex === 0) {
      this.verifyClearHistory(this._handleClearHistoryCallback.bind(this))
    } else if (rowIndex === 0 && itemIndex === 1) {
      this.verifyClearWatchlist(this._handleClearWatchlistCallback.bind(this))
    } else {
      this.updateContent(itemIndex);
      this._setState('Content')
    }
  }

  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    Log.info('SettingsScreen:  _getFocused fired')
    return this.tag('MenuWrapper')
  }

  override _focus(): void {
    Log.info('SettingsScreen:  _focus fired')
    this.setSmooth('alpha', 1)
    Logger.processUserAction('leftMenu_settings_Open');
  }

  // override _unfocus(): void {
  //   Log.info('SettingsScreen:  _unfocus fired')
  //   this.setSmooth('alpha', 0)
  //   this.tag('ContentContainer').patch(undefined)
  //   Logger.processUserAction('settingsScreen_Close');
  // }
  verifyClearHistory(callback?: any) {
    const dialogInfo: IDialogueInfo = {
      title: 'Are you sure you want to proceed ?',
      body: '',
      type: DIALOG_TYPE.APP_EXIT_BOX,
      buttons: [
        {
          w: 200,
          name: 'Cancel',
          index: 0,
          action: DIALOG_BUTTON_ACTION.NO,
          initialFocus: true,
        },
        {
          w: 300,
          name: 'Clear History',
          index: 1,
          action: DIALOG_BUTTON_ACTION.YES,
          initialFocus: false
        }
      ]
    }
    if (callback) {
      dialogInfo.callback = callback
      // dialogInfo.callbackData = videoData
    }
    const page: any = Router.getActivePage()
    page.widgets.dialog.showDialog(dialogInfo)
    Router.focusWidget('dialog')
    return true
  }

  verifyClearWatchlist( callback?:any) {
    const dialogInfo: IDialogueInfo = {
      title: 'Are you sure you want to proceed ?',
      body: '',
      type: DIALOG_TYPE.APP_EXIT_BOX,
      buttons: [
        {
          w: 200,
          name: 'Cancel',
          index: 0,
          action: DIALOG_BUTTON_ACTION.NO,
          initialFocus: true,
        },
        {
          w: 300,
          name: 'Clear Queue',
          index: 1,
          action: DIALOG_BUTTON_ACTION.YES,
          initialFocus: false
        }
      ]
    }
      if(callback) {
        dialogInfo.callback = callback
        // dialogInfo.callbackData = videoData
      }
      const page:any = Router.getActivePage()
      page.widgets.dialog.showDialog(dialogInfo)
      Router.focusWidget('dialog')
      return true
  }

  _handleClearHistoryCallback(actionBtn:any, dialogInfo:IDialogueInfo){
    if(actionBtn.action == DIALOG_BUTTON_ACTION.YES) {
      Logger.processUserAction('Settings_clearRecentlyWatched');
      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      // app?.handleBackNavigation(this.prevPage)
      Router.navigate('main-grid-screen/' + 0, false)
      app?.clearRecentlyWatched().then(() => {
        Router.reload()
      })
    }
  }

    _handleClearWatchlistCallback(actionBtn: any, dialogInfo: IDialogueInfo) {
        if (actionBtn.action == DIALOG_BUTTON_ACTION.YES) {
            Logger.processUserAction('Settings_clearWatchlist');
            const { appState } = AppData as AppSetup
            const app = appState?.getApp()
            Router.navigate('main-grid-screen/' + 0, false)
            app?.queueManager.removeFromQueue(null, null, null, true);
        }
    }

  updateContent(index: number) {
    const selectedMenu = this.moreOptions[this.selectedRow][this.selectedColumn]
    this.tag('ContentContainer').patch({ alpha: 1, Content: undefined, collision: true });

    const { appState, platform, appConfig } = AppData as AppSetup
    const aboutArry = [
      { key: 'DeviceModel', value: platform?.getFullModel() },
      { key: 'DeviceId', value: platform?.getDeviceId() },
      { key: 'IP Address', value: platform?.getIp() || '' },
      { key: 'BuildVer', value: appConfig?.buildVersion },
      { key: 'UserAgent', value: window.navigator.userAgent },
    ]
    this.showHideMenu(false)
    // Log.info('SettingsScreen: updateContent')
    // if(this.menuItems[index].userlog){
    //   Logger.processUserAction(this.menuItems[index].userlog);
    // }
    if (selectedMenu?.userlog) {
        Logger.processUserAction(selectedMenu.userlog);
    }
    // this.tag('ContentContainer').patch({
    //   Content: undefined
    // })
    // this.tag('MenuWrapper').items.map((item, indx) => {
    //   item.itemSelected = (index == indx ? true : false)
    // })
    const headerData = {
      title: selectedMenu?.content,
      description: selectedMenu?.description,
      qrCodeIcon: selectedMenu?.qrCodeIcon
    }
    switch (selectedMenu?.actionIndex) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        this.showHideLoading(true)
        fetchData(getPolicyUrl('aboutus'))
          .then((result) => {
            this.tag('ContentContainer').patch({
              Content: {
                w: (w) => w,
                h: (h) => h,
                type: PolicyTab,
                data: result.data.description.split('\n').join('\n'),
                headerData: headerData
              }
            })
            this.showHideLoading(false)
            this._setState("Content");
            platform?.textToSpeach(result.data.description)
          })
        break;
      case 3:
        this.showHideLoading(true)
        if (appConfig?.enableOnlyURLDisplay) {
          this.tag('ContentContainer').patch({
            Content: {
              w: (w) => w,
              h: (h) => h,
              type: OnlyUrl,
              data: { url: 'https://www.futuretodayinc.com/privacy', name: 'Privacy Policy' },
            }
          })
          this.showHideLoading(false)
          this._setState("Content");
          platform?.textToSpeach('Privacy Policy  Go to link  https://www.futuretodayinc.com/privacy')
          return
        }
        fetchData(getPolicyUrl('privacypolicy'))
          .then((result) => {
            this.tag('ContentContainer').patch({
              Content: {
                w: (w) => w,
                h: (h) => h,
                type: PolicyTab,
                data: result.data.description.split('\n\n\n\n').join('\n'),
                headerData: headerData
              }
            })
            this.showHideLoading(false)
            this._setState("Content");
            platform?.textToSpeach(result.data.description)
          })
        break;
      case 4:
        this.showHideLoading(true)
        if (appConfig?.enableOnlyURLDisplay) {
          this.tag('ContentContainer').patch({
            Content: {
              w: (w) => w,
              h: (h) => h,
              type: OnlyUrl,
              data: { url: 'https://www.futuretodayinc.com/terms', name: 'Terms Of Use' }
            }
          })
          this.showHideLoading(false)
          this._setState("Content");
          platform?.textToSpeach('Terms Of Use  Go to link  https://www.futuretodayinc.com/terms')
          return
        }
        fetchData(getPolicyUrl('termsofuse'))
          .then((result) => {
            this.tag('ContentContainer').patch({
              Content: {
                w: (w) => w,
                h: (h) => h,
                type: PolicyTab,
                data: result.data.description.split('\n\n\n\n').join('\n'),
                headerData: headerData
              }
            })
            this.showHideLoading(false)
            this._setState("Content");
            platform?.textToSpeach(result.data.description)
          })
        break;
      case 5:
        this.showHideLoading(true)
        fetchData(getPolicyUrl('donotsell'))
          .then((result) => {
            this.tag('ContentContainer').patch({
              Content: {
                w: (w) => w,
                h: (h) => h,
                type: PolicyTab,
                data: result.data.description.split('\n').join('\n'),
                headerData: headerData
              }
            })
            this.showHideLoading(false)
            this._setState("Content");
            platform?.textToSpeach(result.data.description)
          })
        break;
      case 6:
        Log.info('SettingsScreen: updateContent case 5', aboutArry)
        this.tag('ContentContainer').patch({
          Content: {
            rect: true,
            w: (w) => w,
            h: (h) => h,
            type: CAInfo,
            data: aboutArry
          }
        })
        let tts = aboutArry.map(item => item?.key + ' ' + item?.value).join(' ')
        platform?.textToSpeach(tts)
        break;
    }
  }

  // onIndexChanged(indexData: any) {
  //   this.index = indexData.index
  // }

  // $ItemSelected() {
  //   Log.info('SettingsScreen: $ItemSelected: ', this.index, this.menuItems)
  //   this.updateContent(this.index)
  // }

  _handleClick(target) {
    // console.log('Settings-screen _handleClick:', target)
    if (target.ref === 'BackButton') {
      Promise.resolve().then(() => {
        this.$handleBack();
      })
      return true;
    }
    if (target && typeof target.rowIndex === 'number' && typeof target.itemIndex === 'number') {
      this.selectedRow = target.rowIndex;
      this.selectedColumn = target.itemIndex;
      this.$enterContent({ rowIndex: target.rowIndex, itemIndex: target.itemIndex });
      return true;
    }
    return false
  }

  override _handleLeft() {
    Log.info('SettingsScreen:', '_handleLeft fired')
    Router.focusWidget('Menu')
    this.isMenuFocused = true;
    return true
  }
  override _handleBack(e: KeyboardEvent): boolean | void {
    Log.info('SettingsScreen: _handleBack fired')
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    app?.handleBackNavigation(this.prevPage)
    Logger.processUserAction('closing Setting Screen');
  }

  $handleBack() {
    if (this._getState() === 'MenuWrapper') {
      Log.info('SettingsScreen:  MenuWrapper _handleBack fired')
      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      app?.handleBackNavigation(this.prevPage)
      Logger.processUserAction('closingSearch');
      return true
    } else if (this._getState() === 'Content') {
      this.showHideMenu(true)
      this._setState('MenuWrapper');
      return true
    }
  }

  static override _states() {
    return [
      class MenuWrapper extends this {
        override _getFocused() {
          return this.tag('MenuWrapper');
        }
        override $enter() {
          this.tag('MenuWrapper').patch({ alpha: 1 });
          this.tag('ContentContainer').patch({ alpha: 0 });
        }
        override _handleEnter() {
          this.$enterContent({ rowIndex: this.selectedRow, itemIndex: this.selectedColumn })
        }
        override _handleBack() {
          this.$handleBack()
        }
        override _handleLeft() {
          Log.info('SettingsScreen: MenuWrapper_handleLeft fired')
          Router.focusWidget('Menu')
          this.isMenuFocused = true;
          return true
        }
        override _handleKey(e: KeyboardEvent): boolean | void {
          Log.info('SettingsScreen:  MenuWrapper _handleKey fired')
          return true
        }

      },

      class Content extends this {
        override _getFocused() {
          return this.tag('Content');
        }

        override $enter() {
          this.tag('MenuWrapper').patch({ alpha: 0 })
          this.tag('ContentContainer').patch({ alpha: 1 })
        }

        override _handleBack() {
          this.$handleBack()
        }

        override _handleKey(e: KeyboardEvent): boolean | void {
          Log.info('SettingsScreen:  Content _handleKey fired')
          return true
        }
      },
    ]
  }
}
